import controller from './controller';
import template from './template.pug';
import styles from './styles.less';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider){

	$stateProvider.state('verifyEmail', {
		url: '/verifyEmail/:emailVerificationToken',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})
}


/** WEBPACK FOOTER **
 ** ./src/guest/verifyEmail/routes.js
 **/